import { render } from "./MemoryManagement.vue?vue&type=template&id=3f4734c6&scoped=true"
import script from "./MemoryManagement.vue?vue&type=script&lang=js"
export * from "./MemoryManagement.vue?vue&type=script&lang=js"

import "./MemoryManagement.vue?vue&type=style&index=0&id=3f4734c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4734c6"]])

export default __exports__